/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : PRODUCT MANAGER: SITE SETUP : ADDITIONAL : STYLES --------------- ++++++++++ */
export default theme => ({
  productcard: {
    textAlign: 'center',
    padding: pxToEm(16),
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #AEB6D6',
    borderRadius: pxToEm(8),
    maxHeight: pxToEm(320),
    gap: pxToEm(16),
    minWidth: pxToEm(350),
    maxWidth: pxToEm(350),
    '&.status-approved': {
      border: '3px solid #061241'
    },
    '& h4': {
      fontWeight: 700,
      fontSize: pxToEm(18)
    },
    '& .name-requestaccess': {
      width: '100% !important',
      borderRadius: pxToEm(12)
    },
    '& .status': {
      height: pxToEm(40),
      fontWeight: 600,
      fontSize: pxToEm(14),
      color: '#5566A9',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: pxToEm(8)
    },
    '& .button': {
      height: pxToEm(40),
      '&:disabled': {
        background: '#DFDFDF !important',
        color: '#000'
      }
    },
    '& .productactions': {
      '& .button': {
        width: '100%'
      }
    }
  }
});
